import type { ChatStatus } from "ai";

export function normalizeChatStatusForUi(status: ChatStatus): ChatStatus {
  return status === "error" ? "ready" : status;
}
